export default {
    props: {
        title: String,
        instruction: String,
        parent: Object
    },
    data() {
        let vm = this;
        return {
            startDate: (this.$store.state.sessionDetails.properties.policy_start !== null) ? this.$store.state.sessionDetails.properties.policy_start : moment().format('YYYY-MM-DD'),
            //endDate: new Date().toISOString().substr(0, 10),
            endDate: (this.$store.state.sessionDetails.properties.policy_expiry !== null) ? this.$store.state.sessionDetails.properties.policy_expiry : moment().add('years', 1).subtract('days', 1).format('YYYY-MM-DD'),//moment(new Date().toISOString().substr(0, 10)).add(365, 'day'),
            menu: false,
            menu2: false,
            switch1: true,
            min_date: "",
            max_date: "",
            policyTermSubmitted: false,
        }
    },
    computed: {
        computedStartDateFormatted() {
            return this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : ''
        },
        computedEndDateFormatted() {
            return this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : ''
        }
    },
    watch: {
        date (val) {
            this.dateFormatted = this.formatDate(this.date)
        },
        startDate (val) {
            // let end_date = moment(this.endDate).format('YYYY-MM-DD');
            // this.endDate = moment(start_date).add(365, 'day').format('YYYY-MM-DD');
            //this.endDate = moment(this.endDate).format('YYYY-MM-DD');
            let start_date = moment(this.startDate).format('YYYY-MM-DD');

            

            this.endDate = moment(start_date).add('years', 1).subtract('days', 1).format('YYYY-MM-DD');
        }
    },
    methods: {
        // test
        checkStoreData() { 
            console.debug('Payload Build Structure', this.$store.getters.sessionPayload);
        },
        allowedDates: val => this.el.indexOf(val) !== -1,
        backToPrevious() {
            this.parent.existingClaimsSubmitted = false;
            
            this.$store.commit('mutate', {
                property: "NewBusinessStep",
                value: this.$store.state.NewBusinessStep - 1
            });
        },
        initApp() {
            this.checkStoreData();
            this.setDisabledDates();
        },
        setDisabledDates(){
            //3o days in the past
            //45 days in the future
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();

            today = yyyy + '-' + mm + '-' + dd;
            today = moment(today).format('YYYY-MM-DD');
            
            this.min_date = moment(today).subtract('days', 30).format('YYYY-MM-DD');
            this.max_date = moment(today).subtract('days', -45).format('YYYY-MM-DD');
           
        },
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },
        parseDate (date) {
            if (!date) return null
            
            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        submitForm() {
            
            this.$store.commit('mutate', {
                property: "sessionDetails.properties.policy_start",
                value: this.startDate
            });

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.policy_expiry",
                value: this.endDate
            });

            // this.$store.commit('mutate', {
            //     property: "NewBusinessStep",
            //     value: this.$store.state.NewBusinessStep + 1
            // });
            this.policyTermSubmitted = true;
            this.$emit("createUpdateSession");
        }
    },
    mounted() {
        this.initApp();
    }
}